import { render, staticRenderFns } from "./DetailsUnitModal.vue?vue&type=template&id=20d62ac0&scoped=true"
import script from "./DetailsUnitModal.vue?vue&type=script&lang=js"
export * from "./DetailsUnitModal.vue?vue&type=script&lang=js"
import style0 from "./DetailsUnitModal.vue?vue&type=style&index=0&id=20d62ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d62ac0",
  null
  
)

export default component.exports